import {useContext} from 'react';
import {FacebookContext} from 'providers';

export const useFacebookContext = () => {
  const context = useContext(FacebookContext);
  if (!context) {
    throw new Error(
      'useFacebookContext must be used within a Facebook Provider'
    );
  }
  return context;
};
